/**
 * Labstep
 *
 * @module components/JupyterNotebook/Form/ShowEdit/Name
 * @desc ShowEdit for name for resource item
 */

import { fieldJupyterNotebookName } from 'labstep-web/components/JupyterNotebook/Form/fields';
import { FormShowEditText as ShowEdit } from 'labstep-web/core/Form/ShowEdit/Text';
import type React from 'react';
import type { IJupyterNotebookFormShowEditNameProps } from './types';

export const JupyterNotebookFormShowEditName: React.FC<
  IJupyterNotebookFormShowEditNameProps
> = ({ jupyterNotebook }) => (
  <ShowEdit
    entityName={jupyterNotebook.entityName}
    entity={jupyterNotebook}
    field={fieldJupyterNotebookName}
  >
    {jupyterNotebook.name}
  </ShowEdit>
);
